import React from 'react';
import { resolveTenantBranding } from '@/utils/tenantBranding';
import { PoweredByVaiuMark } from '@/components/shared/TenantBrandBar';

interface WhiteLabelFooterProps {
  className?: string;
}

/**
 * Minimal partner attribution when a bank logo is primary (header / brand bar).
 */
const WhiteLabelFooter: React.FC<WhiteLabelFooterProps> = ({ className = '' }) => {
  const tenant = resolveTenantBranding();

  if (!tenant.showPoweredByVaiu) {
    return null;
  }

  return (
    <div
      className={`flex items-center justify-center border-t border-gray-200 bg-gray-50 py-3 ${className}`}
    >
      <PoweredByVaiuMark />
    </div>
  );
};

export default WhiteLabelFooter;
